import { Box, Paper } from "@material-ui/core";
import BackupIcon from '@mui/icons-material/Backup';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Tooltip
} from '@mui/material';
import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { styled } from '@mui/material/styles';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';
import 'dayjs/locale/en-gb';
import {
  MaterialReactTable,
  useMaterialReactTable
} from 'material-react-table';
import { useEffect, useMemo, useState } from 'react';
import { Controller, useForm } from "react-hook-form";
import Swal from 'sweetalert2';
import LoaderBar from "../../components/LoaderBar/LoaderBar";
import PageTitle from "../../components/PageTitle/PageTitle";
import PdfUpload from "../../utils/Uploader/PdfUpload";
import axios from '../../utils/axios';

import { Grid, MenuItem } from "@material-ui/core";
import DeleteIcon from '@mui/icons-material/Delete';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import { Autocomplete, TextField } from "@mui/material";
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import 'dayjs/locale/en-gb';
import { Link } from "react-router-dom";
import CMSFICTEmployees from '../../utils/strings/CMSFICTEmployees';

import Notification from '../login/Notification';
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#A7C7E7",
    color: theme.palette.common.black,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));




const SettlementYearEntry = () => {

  const { register, reset,setValue, resetField,control } = useForm();
const [fileURL,setFileURL] = useState("");
  const [data,setData] = useState([]);

  const initialValue = {
    p_settlement_id:0,
    folio_bo_file:fileURL,
    p_settlementdate:"", 
    p_applicationdate:"",
    p_details:[],
    p_nid:"",
    p_isGroupAmount:0,
  
  }
  const [submitValue,setSubmitValue] = useState(initialValue);
const [isLoading,setIsLoading] = useState(false);
const [open,setOpen] = useState(false);
  const [selectedInterimYear, setSelectedInterimYear] = useState("FYI");
    const [nextId,setNextId] = useState(1);
    const [yearid,setYearId] = useState(0);
    const [amount,setAmount] = useState(0);
     const [year,setYear] = useState("");
       const [showError, setShowError] = useState(false);
         const [issuerYear,setIssuerYear] = useState([]);
           const [InterimList, setInterimList] = useState([]);
const enableAdd = submitValue.settlementId !== 0  && submitValue.folio_bo_file !=="" && submitValue.p_details.length > 0;

const userID = JSON.parse(localStorage.getItem("user-id"));
 const authenticated = CMSFICTEmployees.find(item=> { return(item == userID)})
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '60%',
  bgcolor: 'background.paper',
  border: '2px solid #eee',
  boxShadow: '2px 2px 2px 2px #eee',
  borderRadius:"10px",
  p: 4
};

  const handleSubmit = (id,table) =>{
    console.log(submitValue);
       const formdata = new FormData();
       formdata.append('p_settlement_id',submitValue.p_settlement_id);
       formdata.append('p_settlementdate',submitValue.p_settlementdate);
       formdata.append('p_applicationdate',submitValue.p_applicationdate);
       formdata.append("p_details",JSON.stringify(submitValue.p_details));
       formdata.append("folio_bo_file",submitValue.folio_bo_file);
       formdata.append("p_nid",submitValue.p_nid);
       formdata.append("p_isGroupAmount",submitValue.p_isGroupAmount);
          axios.post('settlement/save-settlemt-details',formdata)
          .then((res)=>{
            if(res.data.statusCode===200)
            {
              setSubmitValue(initialValue);
              Swal.fire({
                customClass: {
                  container: 'my-swal'
                },
                icon: 'success',
                title: 'Settlement Details Updated & PDF Uploaded!',
                showConfirmButton: true,
                // timer: 3000
              })
              .then((res)=>{
                if(res.isConfirmed)
                {
                    setData((prevData) => prevData.filter((item) => item.settlement_id !== id));
                    table.setEditingRow(null);
                    setFileURL("");
                    setSubmitValue(initialValue);
                    window.location.reload();
                }
              })
              
            }
            else{
                Swal.fire({
                    customClass: {
                    container: 'my-swal'
                    },
                    icon: 'error',
                    title: res.data.message,
                    showConfirmButton: true,
                    // timer: 3000
                })
            }
          })
          .catch((err)=>{
            console.log(err)
            Swal.fire({
                customClass: {
                  container: 'my-swal'
                },
                icon: 'error',
                title: "Sommething went wrong!",
                text: err.response.data.message,
                showConfirmButton: true,
                
              })
          })
  }
  
  const handleYear = (issueruuid)=>{
    
    if(issueruuid)
    axios.get(`/issuer-year-format/${issueruuid}`)
    .then((res)=>{
      // console.log(res?.data?.payload);
      // res.data.payload.push({id:0,year:"No value Selected"})
      setIssuerYear(res?.data?.payload);
      setSubmitValue(prevState => ({
        ...prevState,
        p_details: []
      }));
      
    })
    .catch((err) =>{
      console.log(err.response.data.message)
    })
    
  }

const DividendYearInterim = () => {
    axios.get('/form-year-type/list')
    .then((res)=>{
      setInterimList(res.data.payload);
    })
  }

  const handleGroupAmount = (e) =>{
    setSubmitValue(prevState => ({
      ...prevState,
      p_isGroupAmount:1,
    }));
  }

  const handleDelete = (trackid) => {
  // Filter out the item with the matching trackid

  const updatedDetails = submitValue.p_details.filter(item => item.trackid !== trackid);
  // Update the state with the new array
  setSubmitValue(prevState => ({
    ...prevState,
    p_details: [...updatedDetails]
  }));
};
    
//     const handleAddSettledYearAmount = () =>{
//   // console.log(yearid,amount);

//   // const disabled = disabledYears.find(year=>year==yearid)
//   if(yearid>0 && amount>0 )
//   {
//     // submitValue.p_details.push({issuerYeaFormatId:yearid,amount:amount,year:year,status:1,interimYear:selectedInterimYear});
//     // console.log(submitValue.p_details);
//     const newEntry = {
//       trackid: nextId, // Assign the next unique ID
//       issuerYeaFormatId: yearid,
//       yearAmount: amount,
//       year: year,
//       status: 1,
//       interimYear: selectedInterimYear,
//       suspenseAmount:0,
      
//       get amount() { return this.yearAmount  + this.suspenseAmount; }
//     };
//     setSubmitValue(prevState => ({
//       ...prevState,
//       p_details: [...prevState.p_details, newEntry],
//     }));
//       setAmount('');
//       setValue('yearid','');
      
//       setValue('amount','');
//     // Increment the nextId for the next entry
//     setNextId(nextId + 1);
//   }
//   else
//   {
//     // alert("Please Enter a valid year and amount.");
//     setShowError(true);

    
//   }
  

// }
const handleAddSettledYearAmount = () =>{
  // console.log(yearid,amount);

  // const disabled = disabledYears.find(year=>year==yearid)
  if(yearid>0 && amount>0 )
  {
    // submitValue.p_details.push({issuerYeaFormatId:yearid,amount:amount,year:year,status:1,interimYear:selectedInterimYear});
    // console.log(submitValue.p_details);
    const newEntry = {
      trackid: nextId, // Assign the next unique ID
      issuerYeaFormatId: yearid,
      yearAmount: amount,
      year: year,
      status: 1,
      interimYear: selectedInterimYear,
      suspenseAmount:0,
      
      get amount() { return this.yearAmount  + this.suspenseAmount; }
    };
    setSubmitValue(prevState => ({
      ...prevState,
      p_details: [...prevState.p_details, newEntry],
    }));

    // Increment the nextId for the next entry
    setNextId(nextId + 1);
 
      // setDisabledYears([...disabledYears, yearid]);

      // Clear the fields after adding
      // setYear('');
      // setYearId('');
      setAmount('');
      setValue('yearid','');
      
      setValue('amount','');
  }
  else
  {
    // alert("Please Enter a valid year and amount.");
    setShowError(true);

    
  }
  

}

  const columns = useMemo(
    //column definitions...
    () => [
      {
            accessorKey: 'sid',
            header: 'SettlementID ',
      },
      {
        accessorKey: 'settlementno',
        header: 'Settlement No',
      },
      {
        accessorKey: 'iissuerid',
        header: 'Issuer ID',
        size: 50,
      },
      
      {
        accessorKey: 'totalamount',
        header: 'Amount',
      }
    ],
    [],
    //end
  );

  const table = useMaterialReactTable({
    columns,
    data:data,
    // enableExpandAll: false, //disable expand all button
    // editDisplayMode: 'modal',
    initialState: { density: 'compact' },
    enableEditing: true,
    enableStickyHeader: true,
    enableStickyFooter: true,
    muiPaginationProps: {
      rowsPerPageOptions: [5, 10, 15, 20, 25, 30, 50, 100, data.length]
    },
    muiTableContainerProps: {

      style: { maxHeight: '60vh' } 

  },
    getRowId: (row) => row.id,
    renderTopToolbarCustomActions: ({ table }) => (
      <Box
        sx={{
          display: 'flex',
          gap: '16px',
          padding: '8px',
          flexWrap: 'wrap',
        }}
      >
     
      </Box>
    ),
 
    muiEditRowDialogProps: ({ table, row, internalEditComponents }) => {
        return {
          maxWidth: 'xl'
        }
      },
    renderRowActions: ({ row, table }) => (
    //   <Box sx={{ display: 'flex', gap: '1rem' }}>
        <Tooltip title="Edit">
          <Button variant = "contained" color="secondary" disabled={table.getSelectedRowModel().rows.length >1} 
          onClick={() => {table.setEditingRow(row);
                        handleYear(row.original.iissuerid);
                            setSubmitValue(prevState => ({
                                ...prevState,
                                p_settlement_id:row.original.sid
                                }));
                    }}>
             <BackupIcon/>&nbsp;Update
          </Button>
        </Tooltip>
    //   </Box>
    ),
    onEditingRowCancel:({table,row})=>
        {
            setFileURL("");
            setSubmitValue(prevState => ({
                ...prevState,
                folio_bo_file:""
                }));
            setAmount(0);
            setYearId(0);
            setYear("");
        }
    ,
    renderEditRowDialogContent: ({ table, row, internalEditComponents }) => (

      <>
        
        
          <DialogTitle>Update Settlement Document</DialogTitle>
          <DialogContent >
          <div style={{border:"1px solid gray",borderRadius:"5px",width:"100%",padding:"10px",margin:"5px",textAlign:"center"}}>

       <Grid container spacing ={3}>
            <Grid item lg={4} md={6} sm={12} xs={12} >
                    <Controller
                            name="p_applicationdate"
                            control={control}
                            render={({ field: { onChange, value } })  => (
                                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'en-gb'}>
                                <DatePicker sx={{margin:"3px",width:"100%"}}
                                label="Application Date"
                                disableFuture
                                value={value ? dayjs(value) : null} 
                                {...register("p_applicationdate")}
                                    onChange={(date) => {
                                    date = date ? date.format("YYYY/MM/DD") : "";
                                    onChange(date);
                                    setSubmitValue(prevState => ({
                                    ...prevState,
                                    p_applicationdate:date
                                    }));
                                }
                                    
                                    
                                    }
                                    renderInput={(params) => (
                                    <TextField
                                        fullWidth
                                        {...params}
                                        label="Application Date"
                                        variant="outlined"
                                        style={{ margin: "5px" }}
                                    />
                                    )}
                                />
                                </LocalizationProvider>
                            )}
                            />
                            {submitValue.p_applicationdate === "" && (
                                            <span style={{ color: "red" }}>Application Date required</span>
                                            )}
            </Grid>
            <Grid item lg={4} md={6} sm={12} xs={12} >
                    <Controller
                    name="p_settlementdate"
                    control={control}
                    render={({ field: { onChange, value } })  => (
                        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'en-gb'}>
                        <DatePicker sx={{margin:"3px",width:"100%"}}
                        label="Claim Recieved Date"
                        disableFuture
                        value={value ? dayjs(value) : null} 
                        {...register("p_settlementdate")}
                            onChange={(date) => {
                            date = date ? date.format("YYYY/MM/DD") : "";
                            onChange(date);
                            setSubmitValue(prevState => ({
                            ...prevState,
                            p_settlementdate:date
                            }));
                        }
                            }
                            renderInput={(params) => (
                            <TextField
                                fullWidth
                                {...params}
                                label="Claim Recieved Date"
                                variant="outlined"
                                style={{ margin: "5px" }}
                            />
                            )}
                        />
                        </LocalizationProvider>
                    )}
                    />
                    {submitValue.p_settlementdate === "" && (
                                    <span style={{ color: "red" }}>Claim Recieved Date required</span>
                                    )}
            </Grid>
            <Grid item  lg={4} md={6} sm={12} xs={12} >
                  <TextField fullWidth variant="outlined" type="text" name = "p_nid" label="NID (must be 10, 13, or 17 digits)" style={{ margin: "5px 0", width: "100%" }}
                    onChange={(e)=>{
                      setSubmitValue(prevState => ({
                        ...prevState,
                        p_nid: e.target.value
                      }));
                    }}
                  {...register("p_nid")} />
                  </Grid>
</Grid>
            <Grid item xs={12} md={12} style={{margin:"10px 50px 10px 50px" ,padding:"20px",boxShadow:"2px 2px 2px 2px gray" ,border:"2px solid slateblue",borderRadius:"5px"}}>
              <div style={{marginBottom:"5px",textAlign:"left",color:"slateblue"}}><h2>Dividend Details</h2></div>
    <Box
          component="form"
          sx={{
            '& > :not(style)': { m: 1, width: '100%' }, // Full width on small screens
          }}
          noValidate
          autoComplete="off"
          style={{ textAlign: 'center',margin:"20px"}}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault(); // Prevent form submission
              handleAddSettledYearAmount(); // Custom handler
            }
          }}
        >
          <Grid container spacing={3} >
            <Grid item xs={12} md={6} lg={4}>
              {
                submitValue.p_id === ""
                ?
                (<h4 style={{color:"red",textAlign:"center"}}>Select Issuer Name</h4>)
                :
                (
                issuerYear.length > 0
                ?
                <>
           
            <Controller
                            name="yearid"
                            control={control}
                            render={({ field, fieldState: { error } }) => {
                              const { onChange, value, ref } = field;
                              return (
                                <>
                                  <Autocomplete
                                      value={
                                        value
                                          ? issuerYear.find((option) => option.id === value) ?? null
                                          : null
                                      }
                                      getOptionLabel={(option) => `${option.year}` || ""} // Use the correct key (bankName) for display
                                      onChange={(event, data) => {
                                        // Update form value using onChange
                                        onChange(data ? data.id : "");  // Update value for Controller
                                        
                                        // Update the state with additional fields
                                        if (data) {
                                          setYearId(data.id);
                                          setYear(data.year);
                                        }
                                      }}
                                      options={issuerYear}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          label={"Select Year"}
                                          style={{  width: "100%" }}
                                          inputRef={ref}
                                          error={!!error}
                                          helperText={error ? error.message : ""}
                                        />
                                      )}
                                    />
                                </>
                          
                              );
                            }}
                          />
                          </>
              :
              // <TextField style={{color:"red",textAlign:"center"}} fullWidth label=" Issuer Name not selected / Issuer year not defined"  disabled/>
              <h4 style={{color:"red",textAlign:"center"}}> <Link to="/app/issuer/yearDefine">Define Issuer Year</Link></h4>)
              }
            </Grid>

            <Grid item xs={12} md={6} lg={4}>
            <Controller
                name="interim"
                control={control}
                render={({ field: { onChange, value } }) => (
              <TextField
                select
                fullWidth
                name="interim"
                value={value}
                defaultValue= {"FYI"}
                label="Select Interim Year"
                variant="outlined"
                className="input-field"
                style={{ margin: "0 15px" }}
                onChange={(event, newValue) => {
                  onChange(event.target.value);
                  setSelectedInterimYear(event.target.value);
                }}
              >
                {InterimList?.map((option, index) => (
                  <MenuItem
                    key={index}
                    value={option.name}
                    style={{ fontSize: 13, fontWeight: "bold" }}
                  >
                    {option.description + ' ('+option.name+ ') '}
                  </MenuItem>
                )
                )}
              </TextField>
                )}/>
              
            </Grid>

            <Grid item xs={12} md={12} lg={4}>
              <Controller
                name="amount"
                control={control}
                render={({ field: { onChange, value } }) => (
                  <TextField
                    fullWidth
                    variant="outlined"
                    type="number"
                    InputProps={{ inputProps: { min: 0} }}
                    value={value}
                    onChange={(event) => {
                      const numericValue = event.target.value === '' ? '' : Number(event.target.value);
                      onChange(numericValue);
                      setAmount(numericValue);
                    }}
                    label="Cash Amount / Stock Amount"
                    style={{ margin: "0 15px" }}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} md={12} >
            <div>
              <FormControlLabel control={<Checkbox defaultChecked={submitValue.p_isGroupAmount} onChange={handleGroupAmount}/>} label="Is Group Amount?"/>

            </div>
              <Button
                variant="contained"
                color='info'
                style={{color: "white" , padding:"10px",backgroundColor:"slateblue"}}
                onClick={handleAddSettledYearAmount}

              >
                <PlaylistAddIcon /> &nbsp; &nbsp;Add
              </Button>
            </Grid>
          </Grid>
        </Box>
        {showError && (
        <Notification message={"Please enter the dividend year and amount"} open={true} handleClose={()=>setShowError(false)} color='red' />
      )}
        {
                submitValue.p_details.length> 0 
                ?
                <Paper style={{ margin:"10px 50px 10px 50px",padding:0,boxShadow:"2px 2px 2px 2px gray",justifyContent:"center"}} container spacing={2} >
                <TableContainer component={Paper} sx={{ width: '100%',maxHeight: 440}}>
              <Table sx={{ minWidth: 700 }} stickyHeader aria-label="simple table">
                <TableHead >
                  <TableRow>
                    <StyledTableCell align="center"  style={{fontSize:"1rem"}}>Year</StyledTableCell>
                    <StyledTableCell align="center"  style={{fontSize:"1rem"}}>Interim</StyledTableCell>
                    <StyledTableCell align="center"  style={{fontSize:"1rem"}}>Cash / Stock</StyledTableCell>
                    {
                        authenticated ? 
                        <StyledTableCell align="center" style={{fontSize:"1rem"}}>Suspense Amount</StyledTableCell> : null
                        
                    }
                    {
                      authenticated ? 
                      <StyledTableCell align="center" style={{fontSize:"1rem"}}>Total Amount</StyledTableCell> : null
                    }
                    <StyledTableCell align="center" colSpan={2} style={{fontSize:"1rem"}}> Delete</StyledTableCell>
                    {/* <StyledTableCell align="center" style={{fontSize:"1rem"}}></StyledTableCell> */}
                  </TableRow>
                </TableHead>
                <TableBody style={{overflow:"hidden",maxHeight:440}}>
                  {submitValue.p_details.toReversed().map((row) => (
                    <StyledTableRow key={row.trackid}>
                      <StyledTableCell align="center">{row.year}</StyledTableCell>
                      <StyledTableCell align="center">{row.interimYear}</StyledTableCell>
                      <StyledTableCell align="center">{row.yearAmount}</StyledTableCell>
                      {authenticated ? <StyledTableCell align="center">
        
        <TextField
        style={{margin:"2px",width:"50%",justifyContent:"center"}}
        InputProps={{ inputProps: { min: 0} }}
          value={row.suspenseAmount}
          onChange={(e) => {
            const suspenseAmt = Number(e.target.value);;
            setSubmitValue(prev => ({
              ...prev,
              p_details: prev.p_details.map(item =>
                item.trackid === row.trackid
                  ? {
                      ...item,
                      suspenseAmount: suspenseAmt,
                      amount: item.yearAmount + suspenseAmt,
                    }
                  : item
              )
            }));
            
            
            
          }}
          type="number"
          size="small"
        />
      
    </StyledTableCell> : null}
                      
    {authenticated ?  <StyledTableCell align="center" style={{fontSize:12}}>
      {row.amount}
      </StyledTableCell> : null}
     
                      <StyledTableCell align="center" ><Button style={{margin:"2px"}}  variant="outlined" color="error" onClick={()=>{handleDelete(row.trackid)}} startIcon={<DeleteIcon />}>Delete</Button></StyledTableCell>

                    </StyledTableRow>
                  ))}
                  <StyledTableRow  sx={{
                                position: "sticky",
                                bottom: 0,
                               backgroundColor: "#A7C7E7 !important",
                                zIndex: 2, // Ensures it stays above the content
                              }}>
                  {
                    authenticated ? <StyledTableCell  align="center" style={{fontSize:"1rem"}} colSpan={4}><strong>Total</strong></StyledTableCell> : <StyledTableCell  align="center" style={{fontSize:"1.2rem"}} colSpan={2}><strong>Total</strong></StyledTableCell>
                  }
                  
                  <StyledTableCell align="center"  style={{fontSize:"1rem"}}><strong>{Number(submitValue.p_details.reduce((total, row) => {const amt = parseFloat(row.amount);
                  return total + (isNaN(amt) ? 0 : amt);}, 0)).toFixed(2)}</strong></StyledTableCell>
                  <StyledTableCell colSpan={2}></StyledTableCell>
                    </StyledTableRow>
                </TableBody>
                
              </Table>
            </TableContainer>
            </Paper>
              :
                               
              null  
            }
            </Grid>
            <PdfUpload submitValue={submitValue} setSubmitValue={setSubmitValue}/>
                  
                          
</div>
           </DialogContent>
           <DialogActions style={{justifyContent:"center",padding:"5px"}}>
        
          <div className="form-control" style={{textAlign:"center"}}>
         <div>
         <Button type="submit" disabled={!enableAdd} onClick={()=>{handleSubmit(row.original.settlement_id,table);}} variant="contained" 
            color="success" style={{color:"white"}}>
            <DoneAllIcon/> &nbsp;Update Settlement Details & Upload</Button>
            
             
         </div>
                           
                            </div>
        </DialogActions>
        
        </>   
       
                    
    )

  });
  const getSettlementDetails = () => {
    setIsLoading(true);
    axios.get(`/settlement/get-un-upload-settlement-list/${userID}`)
    .then((res)=>{
      // console.log(res.data.payload);
      setData(res.data.payload);
      setIsLoading(false);
    })
    .catch((err) =>{
      console.log(err.response.data.message)
      setIsLoading(false);
    })
  }

  useEffect(() => {
    DividendYearInterim();
    getSettlementDetails();
   
  
  
  }, [])

  return(
        <>
          <PageTitle title={"Settlement Documents Upload"}></PageTitle>
        
          
          {
             isLoading
             ?
            <LoaderBar/>
            :
            <MaterialReactTable  table={table} />
          }

          
        </>);
};

export default SettlementYearEntry;